"use strict";

const Util = {
  toType (obj) {
    return {}.toString
      .call(obj)
      .match(/\s([a-zA-Z]+)/)[1]
      .toLowerCase();
  },
  formatDate (date) {
    date = new Date(date);

    if (this.isValidDate(date)) {
      let day = date.getUTCDate();
      let month = date.getUTCMonth() + 1;
      return [
        (day < 10 ? "0" : "") + day,
        (month < 10 ? "0" : "") + month,
        date.getUTCFullYear()
      ].join("/");
    } else if (typeof date === "string" && date.search("/") >= 1) {
      var arrdate = date.split("/");
      // eslint-disable-next-line no-eval
      date = new Date(eval(arrdate[2]), eval(arrdate[1]) - 1, eval(arrdate[0]));
      this.formatDate(date);
    }

    return date;
  },
  isValidDate (d) {
    return d instanceof Date && !isNaN(d);
  },
  stringToDate (strdate) {
    var date = new Date();
    if (typeof date === "string" && date.search("/") >= 1) {
      var arrdate = date.split("/");
      // eslint-disable-next-line no-eval
      date = new Date(eval(arrdate[2]), eval(arrdate[1]) - 1, eval(arrdate[0]));
    }
    return date;
  }
};

export default {
  install: Vue => {
    Vue.prototype.$util = Util;
  }
};



// WEBPACK FOOTER //
// ./src/lib/util.js